import { useMemo } from 'react'

import { form } from '../../formState'

import { useTexts } from './hooks/useTexts'

import { Divider } from '@/components/form/preview/layout/Divider'

type Option = {
  label: string
  value: 'ON' | 'OFF'
}

export function AutomatedMessageEnabledField() {
  const texts = useTexts()
  const automatedMessageEnabled = form.useFormField('automatedMessageEnabled')
  const automatedMessageEnabledVisible = automatedMessageEnabled.field.visible

  const options: Option[] = useMemo(
    () => [
      { label: texts.automatedMessageEnabled.values.on, value: 'ON' },
      { label: texts.automatedMessageEnabled.values.off, value: 'OFF' },
    ],
    [texts],
  )
  const {
    meta: { submitting, disabled },
  } = form.useFormMeta()
  const formDisabled = submitting || disabled

  return (
    <>
      {automatedMessageEnabledVisible && <Divider />}
      <form.RadioGroup
        testId="voice-automated-message-enabled"
        options={options}
        name="automatedMessageEnabled"
        validateOn="blur change"
        label={texts.automatedMessageEnabled.label}
        disabled={formDisabled}
      />
    </>
  )
}
